// accessiBe on tap (#363). The script loads on the first tap of the theme trigger.
// accessiBe binds its own click handler at init, so a second click opens the widget.
// accessiBe also draws its own corner trigger. The dashboard config wins over our init
// config, so hideTrigger does not apply. Hide that trigger inside the widget shadow roots.
(() => {
  const trigger = document.querySelector('[data-accessibe-trigger]');
  const configEl = document.getElementById('accessibe-config');
  if (!trigger || !configEl) return;

  const config = JSON.parse(configEl.textContent);
  const READY_TRIES = 50;
  // Every part of the vendor trigger: its icon sets its own visibility, so the button rule alone leaks.
  const HIDE_CSS = '[part^="acsb-trigger"] { visibility: hidden !important; }';
  let loading = false;

  // accessiBe adds .acsb-widget and its document click listener in the same step.
  const whenReady = (callback, tries = READY_TRIES) => {
    if (document.querySelector('.acsb-widget')) return callback();
    if (tries > 0) setTimeout(() => whenReady(callback, tries - 1), 100);
  };

  // visibility, not display: keeps the trigger out of hit testing and the tab order.
  const hideVendorTrigger = () => {
    for (const host of document.querySelectorAll('access-widget-ui')) {
      if (!host.shadowRoot || host.shadowRoot.querySelector('[data-acsb-hide]')) continue;
      const style = document.createElement('style');
      style.dataset.acsbHide = '';
      style.textContent = HIDE_CSS;
      host.shadowRoot.appendChild(style);
    }
  };

  const load = () => {
    loading = true;
    new MutationObserver(hideVendorTrigger).observe(document.body, { childList: true, subtree: true });
    const script = document.createElement('script');
    script.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    script.async = true;
    script.onload = () => {
      window.acsbJS.init(config);
      whenReady(() => {
        hideVendorTrigger();
        trigger.click();
      });
    };
    script.onerror = () => {
      loading = false;
    };
    document.head.appendChild(script);
  };

  trigger.addEventListener('click', (event) => {
    if (window.acsbJS && window.acsbJS.initialized) return;
    event.preventDefault();
    if (!loading) load();
  });
})();

// Lift our button above the theme sticky Add to cart bar (#363 fix 2). Runs on every page.
// The theme shows the bar and sets body.sticky-add-to-cart-active in the same scroll handler
// (0.5s ease). The snippet CSS moves the button in lockstep under that class. This script
// measures the bar height and writes --accessibe-lift = bar height + 12px. The bar sits on
// the bottom edge, so that places the button 12px above it. Re-measured on resize and when
// the bar changes size. No per-frame work.
(() => {
  const BAR = 'sticky-add-to-cart.sticky-add-to-cart';
  const GAP = 12;
  const bars = [...document.querySelectorAll(BAR)];
  if (!bars.length) return;

  const measure = () => {
    const bar = bars.find((el) => el.getBoundingClientRect().height > 0);
    if (!bar) return;
    const height = Math.round(bar.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--accessibe-lift', `${height + GAP}px`);
  };

  bars.forEach((bar) => new ResizeObserver(measure).observe(bar));
  window.addEventListener('resize', measure);
  measure();
})();
